import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CONFIG } from '../../../../config.token';

/** Catch auth errors and redirect to login page. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private config = inject(CONFIG);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
        catchError(error => {
          if (error.status === 401 || error.status === 403) {
            location.href = this.config.LOGIN_URL;
          }
          return throwError(() => error);
        })
    );
  }
}
